export const GENERATE_CLUSTER_GRAPH = "GENERATE_CLUSTER_GRAPH";
export const GENERATE_CLUSTER_ERROR = "GENERATE_CLUSTER_ERROR ";
export const GENERATE_CLUSTER_SUCCESS = "GENERATE_CLUSTER_SUCCESS";
export const OPEN_GRAPH_MODAL = "OPEN_GRAPH_MODAL";
